import { TimeFrame } from "charts/src/types/chart";

import { DateOption } from "@/utils/date-options";

export const timeFrameLimitMap: Record<TimeFrame, number> = {
  Q: 20,
  Y: 15,
  "4Q": 20,
  D: 20,
};

export const timeFrameDateOptionLimitMap: Record<
  TimeFrame,
  Partial<Record<DateOption, number>>
> = {
  Q: {
    "3Y": 12,
    "5Y": 20,
    "10Y": 40,
  },
  Y: {
    "3Y": 3,
    "5Y": 5,
    "10Y": 10,
  },
  "4Q": {
    "3Y": 12,
    "5Y": 20,
    "10Y": 40,
  },
  D: {
    "3Y": 1095,
    "5Y": 1825,
    "10Y": 3650,
  },
};
